import React from "react";
import { Route, Routes } from "react-router-dom";

import BadgesListPage from "~/modules/Badges/BadgesListPage";

const BadgesRouter = (): React.ReactElement => {
  return (
    <Routes>
      <Route index element={<BadgesListPage />} />
    </Routes>
  );
};

export default BadgesRouter;
